/* Seat listicle buy box (sections/lst-seat-buybox.liquid). Vanilla JS, no jQuery or Swiper needed.
   Quantity buttons + the Bangkok ship-by countdown + the Seat / Seat + Back cart and COD wiring,
   taken from smx-seat-pdp.js (the MAX seat product page) so both behave the same. */
(function(){
  var root = document.getElementById('elmax'); if (!root) return;
  root.querySelectorAll('.x-add').forEach(function(b){ b.addEventListener('click', function(){ var i = b.previousElementSibling; i.value = (+i.value || 1) + 1; }); });
  root.querySelectorAll('.x-sub').forEach(function(b){ b.addEventListener('click', function(){ var i = b.nextElementSibling; if ((+i.value || 1) > 1) i.value = +i.value - 1; }); });
})();
	(function () {
	  var box = document.querySelector('#elmax .x-shipping-calculate-date'); if (!box) return;
	  var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 8;
	  var MONTHS = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'];
	  function bkk() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Bangkok', hour12: false })); }
	  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
	  function tick() {
	    var now = bkk();
	    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoff, 0, 0);
	    var tomorrow = new Date(today.getTime() + 86400000);
	    var d0 = new Date(now.getFullYear(), now.getMonth(), now.getDate()), d1 = new Date(d0.getTime() + 86400000);
	    document.querySelectorAll('#elmax .smx-date[data-days="0"]').forEach(function (el) { el.textContent = fmt(d0); });
	    document.querySelectorAll('#elmax .smx-date[data-days="1"]').forEach(function (el) { el.textContent = fmt(d1); });
	    // 25 Oct 2026 (Luka): before the cutoff count to it; after it count to midnight ("ships tomorrow if ordered within"), then to the cutoff again.
	    var target = now < today ? today : d1, dist = target - now;
	    var h = Math.floor(dist / 3600000), m = Math.floor((dist % 3600000) / 60000), sec = Math.floor((dist % 60000) / 1000);
	    var txt = h + ' ชม. ' + m + ' นาที ' + sec + ' วินาที';
	    document.querySelectorAll('#elmax .x-shipping__message--today').forEach(function (e) { e.style.display = now < today ? 'block' : 'none'; });
	    document.querySelectorAll('#elmax .x-shipping__message--tomorrow').forEach(function (e) { e.style.display = now < today ? 'none' : 'block'; });
	    document.querySelectorAll(now < today ? '#elmax .x-remain-time' : '#elmax .x-within-time').forEach(function (e) { e.textContent = txt; });
	  }
	  tick(); setInterval(tick, 1000);
	})();
(function(){
  var D = window.SMX_DATA || {};
  var root = document.getElementById('elmax'); if(!root) return;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var opt = 0;   // TH: "Seat" is pre-selected
  function baht(c){ return '฿' + Math.round(c/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function qty(){ var q = parseInt(root.querySelector('.smx-main-qty').value,10); return q>0?q:1; }
  // Per-unit price for a product at a quantity, from the A/B Quantity Breaks app (same data the pillow page uses).
  // Falls back to the variant's own price if the app data is not there.
  function unit(p, q){
    var d = window.omgQuantityData, fallback = p.price;
    if (!d || !d.offers) return fallback;
    var offer = null;
    d.offers.forEach(function(o){ if (!offer && String(o.status)==='1' && (o.product_list||[]).map(String).indexOf(String(p.pid))!==-1) offer = o; });
    if (!offer || !offer.discount_rule) return fallback;
    var rule = null;
    offer.discount_rule.forEach(function(r){ var f = parseInt(r.buy_from,10)||0; if (f<=q && (!rule || f > (parseInt(rule.buy_from,10)||0))) rule = r; });
    if (!rule) return fallback;
    var v = parseFloat(rule.discount_value)||0;
    if (rule.discount_unit==='fixed' && rule.discount_type==='per_item') return Math.round(v*100);
    if (rule.discount_unit==='percent' || rule.discount_unit==='percentage') return Math.round(p.strike*(1-v/100));
    return fallback;
  }
  function lines(){
    var q = qty(), out = [{p: D.seat, q: q, u: unit(D.seat, q)}];
    if (opt === 1 && D.arc) out.push({p: D.arc, q: q, u: unit(D.arc, q)});
    return out;
  }
  function totals(){
    var t = 0, c = 0;
    lines().forEach(function(l){ t += l.u*l.q; c += Math.max(l.p.strike, l.u)*l.q; });
    return {total: t, compare: c};
  }
  var idInput = root.querySelector('#smx-form-id'), qInput = root.querySelector('#smx-form-qty');
  function render(){
    var tt = totals(), q = qty();
    if (qInput) qInput.value = q;
    if (idInput) idInput.value = D.seat.id;
    root.querySelector('.smx-offer').textContent = baht(tt.total);
    var cut = root.querySelector('.smx-cut'), sc = root.querySelector('.smx-save-col');
    if (tt.compare > tt.total){
      cut.textContent = baht(tt.compare); cut.style.display='';
      root.querySelector('.smx-save').textContent = baht(tt.compare - tt.total); sc.style.display='';
    } else { cut.textContent=''; cut.style.display='none'; sc.style.display='none'; }
    document.dispatchEvent(new CustomEvent('smx:change'));
  }
  // COD form hooks (read by smx-th-cod.js)
  var cfg = window.PCO_REAL_PDP_CONFIG = window.PCO_REAL_PDP_CONFIG || {};
  cfg.extraAddons = function(){
    if (opt !== 1 || !D.arc) return [];
    var q = qty(), u = unit(D.arc, q);
    return [{variantId: String(D.arc.id), qty: q, productTitle: D.arc.title, image: D.arc.image || '', price: u/100, compare: Math.max(D.arc.strike, u)/100}];
  };
  cfg.getTotal = function(){
    var tt = totals(), q = qty();
    var label = opt === 1 ? (q + ' เบาะรองนั่ง + ' + q + ' หมอนรองหลัง') : ('เบาะรองนั่ง MAX - ' + q + ' ชิ้น');
    return {label: label, total: tt.total/100, compare: tt.compare/100};
  };
  function selectOpt(i){
    opt = i;
    root.querySelectorAll('.x-swatch-card').forEach(function(c){ c.classList.toggle('x-active-card', +c.getAttribute('data-opt') === i); });
    var c = root.querySelector('.x-swatch-card[data-opt="'+i+'"]');
    var nm = root.querySelector('.x-item-name'); if (c && nm) nm.textContent = c.getAttribute('data-item');
    render();
  }
  root.querySelectorAll('.x-swatch-card').forEach(function(c){
    c.addEventListener('click', function(){ var i = parseInt(c.getAttribute('data-opt'),10)||0; if (i===1 && !D.arc) return; selectOpt(i); });
  });
  root.querySelectorAll('.x-quantity_row .x-qtyBtn').forEach(function(b){ b.addEventListener('click', function(){ setTimeout(render,0); }); });
  selectOpt(/[?&]bundle=1\b/.test(location.search) && D.arc ? 1 : 0);
  // the Quantity Breaks app data can arrive after this script: re-price once it is there
  var tries = 0, iv = setInterval(function(){ tries++; if (window.omgQuantityData || tries > 20) { clearInterval(iv); render(); } }, 500);

  // Card / other payment: add Seat (and ARC) to the real cart. COD and bank transfer are handled by smx-th-cod.js,
  // which intercepts this same form submit first (capture phase) and never lets it reach here.
  var form = root.querySelector('#smx-atc-form');
  if (form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
    var items = lines().map(function(l){ return {id: l.p.id, quantity: l.q}; });
    fetch(R + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items}) })
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(res){
        if (btn) btn.disabled = false;
        if(!res.ok){ alert((res.j && (res.j.description||res.j.message)) || 'ไม่สามารถเพิ่มลงตะกร้าได้'); return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        if (typeof window.upcartOpenCart === 'function') { try{ window.upcartRefreshCart && window.upcartRefreshCart(); }catch(err){} window.upcartOpenCart(); return; }
        window.location.href = R + 'cart';
      }).catch(function(){ if (btn) btn.disabled = false; window.location.href = R + 'cart'; });
  });
})();
